'use client';
import React from 'react';

import dynamic from 'next/dynamic';
import { useUserWallets } from '@/store';

const WalletCurrencyPreview = dynamic(
	() => import('../WalletCurrencyPreview/WalletCurrencyPreview'),
	{
		ssr: false,
	}
);

const WalletPreview = () => {
	return (
		<div className="md:relative ">
			<WalletCurrencyPreview />
		</div>
	);
};

export default WalletPreview;
